/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFilterFilled: {
  name: 'filter-filled';
  data: string;
} = {
  name: 'filter-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.15 3.043c-.416.099-.825.444-1.018.857l-.112.24-.012 1.303c-.011 1.079-.002 1.35.05 1.576.137.591.071.515 3.128 3.581l2.812 2.82.011 2.82.011 2.82.129.264c.234.478.298.519 2.537 1.635 1.434.715 2.067 1.011 2.198 1.027.288.036.607-.075.816-.284.315-.315.3-.095.3-4.439v-3.842l2.813-2.82c3.058-3.067 2.992-2.991 3.129-3.582.052-.226.061-.497.05-1.576L20.98 4.14l-.113-.244a1.698 1.698 0 0 0-.767-.764l-.24-.112-7.78-.006c-4.438-.004-7.844.009-7.93.029"/></svg>`
};
